/**
 * @desc 积分订单
 */
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { computed } from 'mobx';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
import { BaseModel, BasesController } from '../bases';
@BindAll()
export class PointsOrdersController<T = any> extends BasesController<T> {
  constructor() {
    super();
    this.reset({
      dataKey: 'orderNumber',
      infinite: true,
      details: EnumAPI.points_orders_details, // 根据状态调用的接口不同
      // detailsParams:{
      //     valueGetter: (res) => {
      //         lodash.set(res.mainOrder, '_orderStatusColor', lodash.get({ "0": '', "1": 'blue', "2": 'green', "-1": 'red' }, res.mainOrder.orderStatus, ''))
      //         return res
      //     }
      // },
      pagination: EnumAPI.points_orders_list,
      insert: EnumAPI.orders_create,
      paginationParams: {
        currentKey: 'pageNo',
        pageSizeKey: 'pageSize',
        filterKey: 'search',
        response: { valueGetter: this.paginationValueGetter },
      },
    });
  }

  // 存储当前订单类型（pointsOrder/historyPointsOrder），默认 pointsOrder
  orderType = 'pointsOrder';

  setOrderType(type: 'pointsOrder' | 'historyPointsOrder') {
    if (this.orderType === type) return;
    this.orderType = type;

    this.options.pagination =
      type != 'historyPointsOrder'
        ? EnumAPI.points_orders_list
        : EnumAPI.orders_list;

    super.reset(this.options, true);

    this.Pagination.reset();
  }

  /**
   * 加载详情数据
   * @param body
   * @param AjaxConfig
   * @returns entity
   */
  async onFind(body?: string | number | { [key: string]: any }) {
    const orderStatus = lodash.toString(lodash.get(body, 'orderStatus'));
    return this.Details.onLoad(
      body,
      lodash.includes(['1', '5'], orderStatus) ? EnumAPI.orders_alldetails : {},
    );
  }

  Model = new BaseModel({ type: 'object', storageKey: 'order_status' });

  /**
   * 订单全部状态
   */
  @computed
  get OrderStatus(): Array<any> {
    // return this.Model.get('OrderStatus', [])
    return lodash.get(this.Model.value, 'OrderStatus', []);
  }

  /**
   * 物流信息
   */
  @computed
  get logisticsList(): Array<any> {
    return lodash.get(this.Model.value, 'logisticsList', []);
  }

  // readonly OrderStatus = [
  //     { label: "全部", value: "0" },
  //     { label: "待审核", value: "1" },
  //     { label: "待付款", value: "2" },
  //     { label: "已发货", value: "4" },
  //     { label: "已取消", value: "5" }
  // ]
  /**
   * 转换列表数据
   * @param response
   * @returns
   */
  paginationValueGetter(response) {
    let list = lodash.get(response, 'list', []);
    list = list.map((item) => {
      item.orderItemList = item.orderItemList.map((items) => {
        items.paymentType = item.paymentType;
        items.dealPrice = item.dealPrice;
        items.orderPrice = item.orderPrice;
        return items;
      });
      return item;
    });
    // 铺开所有数据
    const flatten = lodash.flatten(lodash.map(list, 'orderItemList'));
    // 根据 orderNumber 分组
    const group = lodash.groupBy(flatten, (item) => item.orderNumber);
    // 重组数据
    const dataSource = lodash.map(group, (val, key) => {
      // 计算 单价*数量
      function multiply(product) {
        const sum = lodash.multiply(
          lodash.get(product, 'price', 0),
          lodash.get(product, 'amount', 0),
        );
        const child = lodash.sumBy(lodash.get(product, 'child'), (prt) =>
          lodash.multiply(
            lodash.get(prt, 'price', 0),
            lodash.get(prt, 'amount', 0),
          ),
        );
        return lodash.sum([sum, child]);
      }
      // 求总价格
      // const dealPrice = lodash.sumBy(val, (prt) => multiply(prt));
      const actionList = lodash.map(
        lodash.filter(lodash.get(val, `[0].actionList`), [
          'operationValue',
          '1',
        ]),
        (ord) =>
          // 转换按钮
          lodash.assign({}, ord, {
            operationRemark: lodash.head(
              lodash.split(ord.operationRemark, '按钮'),
            ),
          }),
      );
      return {
        orderItemList: val,
        dealPrice: lodash.get(val, `[0].dealPrice`),
        orderPrice: lodash.get(val, `[0].orderPrice`),
        orderNumber: lodash.get(val, `[0].orderNumber`),
        orderId: lodash.get(val, `[0].orderId`),
        orderStatus: lodash.get(val, `[0].orderStatus`),
        orderStatusName: lodash.get(val, `[0].orderStatusName`),
        actionList,
        paymentType: lodash.get(val, `[0].paymentType`),
      };
    });
    console.log(
      'LENG ~ OrdersController<T ~ dataSource ~ dataSource',
      dataSource,
    );
    return {
      total: lodash.get(response, 'count'),
      dataSource,
    };
  }

  /**
   * @ 订单的状态
   */
  async getOrderStatus() {
    try {
      // if (this.OrderStatus.length) {
      //     return
      // }
      let res = await AjaxBasics.requestEnum(
        { ...EnumAPI.product_orderStatus, body: { id: '50031' } },
        { labelKey: 'name', valueKey: 'value' },
      );
      res = lodash.map(res, (item) => {
        lodash.set(
          item,
          '_statusIcon',
          lodash.get(
            {
              '1': 'quanbudingdan',
              '2': 'daishenhe',
              '3': 'a-bianzu19',
              '4': 'daiquerenshoukuan',
              '5': 'gerenzhongxin-daifahuo',
              '6': 'replay',
            },
            item.original.sort,
          ),
        );
        return item;
      });
      this.Model.merge({ OrderStatus: res });
    } catch (error) {}
  }

  /**
   * @ 取消订单
   */
  async orderCancel(body) {
    //
    let url =
      this.orderType == 'pointsOrder'
        ? EnumAPI.points_order_cancel
        : EnumAPI.order_cancel;
    return await AjaxBasics.request({ ...url, body });
  }

  async submitPayInfo(body) {
    return await AjaxBasics.request({ ...EnumAPI.order_submitpayinfo, body });
  }

  /** 根据订单的id获取物流信息 */
  async getlogisticsList(orderNumber) {
    const res = await AjaxBasics.request<any>({
      ...EnumAPI.order_getstockinfo,
      body: { orderNumber },
    });
    this.Model.merge({
      logisticsList: res.orderLogisticsInformationPackageList,
    });
  }
  /** 根据订单的id获取支付信息 */
  async getPayInfo(orderNumber) {
    const res = await AjaxBasics.request<any>({
      ...EnumAPI.order_getpayinfo,
      body: { orderNumber },
    });
    return res;
    // this.Model.merge({ logisticsList: res.orderLogisticsInformationPackageList })
  }

  /** 根据订单的id获取支付信息 */
  async getCollectionInfo(code) {
    const res = await AjaxBasics.request<any>({
      ...EnumAPI.order_getcollectioninfo,
      body: { code },
    });
    return res;
  }

  clearLogisticsList() {
    this.Model.merge({ logisticsList: [] });
  }
  /**
   * @ 上传支付凭证
   */
  async uploadPayImg(file) {
    const body = new FormData();
    body.append('file', file);
    const res = await AjaxBasics.request<any>({
      ...EnumAPI.order_pay_upload_img,
      body,
    });
    return res;
  }

  /**
   * 创建订单
   * @param {*} product 原始的商品数据
   * @param {*} address 原始的地址数据
   * @return {*}
   * @memberof OrdersController
   */
  onCreateOrder(product, address) {
    return this.onInsert({
      orderProductInfoList: lodash.map(product, (item) => ({
        shoppingCartId: item.id,
        productId: item.productId,
        commodityQuantity: item.productNum,
        storeName: lodash.get(item, 'storeName', ''),
        storeCode: lodash.get(item, 'storeCode', ''),
        storeAddress: lodash.get(item, 'storeAddress', ''),
      })),
      orderReceivingInfo: {
        provinceName: lodash.get(address, 'provinceName'),
        provinceCode: lodash.get(address, 'provinceId'),
        cityName: lodash.get(address, 'cityName'),
        cityCode: lodash.get(address, 'cityId'),
        areaName: lodash.get(address, 'countyName'),
        areaCode: lodash.get(address, 'countyId'),
        consigneeName: lodash.get(address, 'consignee'),
        contactNumber: lodash.get(address, 'mobile'),
        detailedAddress: lodash.get(address, 'details'),
        bppAddId: lodash.get(address, 'id'),
        shipToPrartCode: lodash.get(address, 'addressCode', ''),
        source: lodash.get(address, 'source'),
      },
    });
  }

  /**
   * 积分创建订单
   * @param {*} product 原始的商品数据
   * @param {*} address 原始的地址数据
   * @return {*}
   * @memberof OrdersController
   */
  async onScoreCreateOrder(product, address, buType) {
    let orderProductInfoList = lodash.map(product, (item) => ({
        productId: item.agreementproductId,
        channelProductType: item.productType,
        commodityQuantity: item.productNum,
        productDescription: item.productDescription,
        productName: item.productName,
        thumbnailAddress: item.productImg,
        vendor: item.dealerName,
        vendorCode: item.dealerId,
      })),
      body = {
        orderProductInfo: orderProductInfoList[0],
        orderReceivingInfo: {
          provinceName: lodash.get(address, 'provinceName'),
          provinceCode: lodash.get(address, 'provinceId'),
          cityName: lodash.get(address, 'cityName'),
          cityCode: lodash.get(address, 'cityId'),
          areaName: lodash.get(address, 'countyName'),
          areaCode: lodash.get(address, 'countyId'),
          consigneeName: lodash.get(address, 'consignee'),
          contactNumber: lodash.get(address, 'mobile'),
          detailedAddress: lodash.get(address, 'details'),
          bppAddId: lodash.get(address, 'id'),
          shipToPrartCode: lodash.get(address, 'addressCode', ''),
          source: lodash.get(address, 'source'),
        },
      };
    const res = await AjaxBasics.request<any>({
      ...(buType === 'BU006'
        ? EnumAPI.order_scoreSubmitISG
        : EnumAPI.order_scoreSubmit),
      body,
    });
    return res;
  }

  /**
   * @ 积分兑换验证
   */
  async scoreVerify(body) {
    return await AjaxBasics.request({ ...EnumAPI.order_scoreVerify, body });
  }

  /**
   * @ 积分兑换验证账号是否有兑换权限
   */
  async scoreCheckActivation() {
    return await AjaxBasics.request({ ...EnumAPI.order_scoreCheckActivation });
  }

  /** 根据订单编号获取订单结果 */
  async getSingleOrderPollingResult(orderNoList) {
    const res = await AjaxBasics.request<any>({
      ...EnumAPI.order_getSingleOrderPollingResult,
      body: { orderNoList },
    });
    return res;
  }

  /** 根据订单的id获取物流信息 */
  async getAllOrderPollingResult() {
    const res = await AjaxBasics.request<any>({
      ...EnumAPI.order_getAllOrderPollingResult,
    });
    return res;
  }

  /** 根据订单的id获取物流信息 */
  async clearOrderFailed(orderNoList) {
    const res = await AjaxBasics.request<any>({
      ...EnumAPI.order_clearOrderFailed,
      body: { orderNoList },
    });
    return res;
  }

  /**
   * @ ISG积分兑换验证
   */
  async scoreCheckActivationISG(body) {
    return await AjaxBasics.request({
      ...EnumAPI.order_scoreCheckActivationISG,
      body,
    });
  }

  /**
   * @ 获取门店列表
   */
  async getShopList() {
    return await AjaxBasics.request<any>({
      ...EnumAPI.order_getShopList,
    });
  }
}
